import { Component, OnDestroy,Renderer2} from '@angular/core';
import { Store } from '@ngrx/store';
import { untilDestroyed } from 'ngx-take-until-destroy';
import { ContentConfig } from '@awp/content';
import { ThemeService } from '@awp/theme';
import { ResetStateAction, ThemeChangedAction } from './state/actions';
import { take, skipWhile } from 'rxjs/operators';
import { AuthenticateAction } from '@awp/data/api';
import { AppConfig } from '@awp/core/config';

@Component({
  selector: 'ap-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnDestroy {

  constructor(
    private renderer: Renderer2,
    private _appConfig: AppConfig,
    contentConfig: ContentConfig,
    themeService: ThemeService,
    store: Store<any>) {

    contentConfig.currentLang = 'en-AU';
    themeService.changes
      .pipe(untilDestroyed(this))
      .subscribe(themeId => store.dispatch(new ResetStateAction()));

    // Notify once theme has loaded.
    themeService.loaded
      .pipe(
        skipWhile(p => p === false),
        take(1)
      )
      .subscribe(p => {
        store.dispatch(new AuthenticateAction());
        store.dispatch(new ThemeChangedAction(themeService.themeId));
      });
      this.loadScript();
  }

  loadScript()
  {
    const script = this.renderer.createElement('script');
    script.type = 'text/javascript'; 
    script.src = `https://client.px-cloud.net/${this._appConfig.CLIENT_PX_TAG}/main.min.js`;
    script.async = true; 
    this.renderer.appendChild(document.head, script);
  }

  ngOnDestroy(): void { }
}
